export default __webpack_public_path__ + "static/media/contactMailDark.1db650d3.svg";